import React from 'react'

interface Props{
    text: string
}

const LoaderButton = (props: Props) => {
  return (
    <div className='w-full flex justify-center items-center gap-2 font-semibold rounded-full transition'>
                        <svg
                          className="animate-spin h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                          />
                        </svg>
                        {props.text}
                      </div>
  )
}

export default LoaderButton
